import globalState from '@/lib/globalState';

export default function overloadTags(
  category: string,
  tags: {
    category: string | null;
    title: string | null;
    id: number | null;
  }[]
) {
  if (category === 'Price') {
    // create list of $ to $$$$ options

    const priceTags = [];
    for (let i = 1; i <= 4; i += 1) {
      const title = '$'.repeat(i);
      const exists = tags.find((option) => option.title === title);
      // override currency symbol from Global
      const symbol = globalState?.siteConfig?.currencySymbol;
      const localLabel = symbol && symbol !== '$' ? symbol.repeat(i) : title;
      if (exists) {
        priceTags.push({ ...exists, title: localLabel, disabled: false });
      } else {
        priceTags.push({ category, title: localLabel, id: -i, disabled: true });
      }
    }

    return priceTags;
  }

  return tags;
}
